module.exports = __webpack_public_path__ + "b2db29c2fac3176044878bb28de0ad06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox-exchange.png
// module id = 161
// module chunks = 0 1